/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum WaitingItemNotificationType {
    BOTH = 0,
    ACOUSTIC_ONLY = 1,
    VISUAL_ONLY = 2,
}
